import { TikTokEmbed } from 'react-social-media-embed';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';


import { Container, Snackbar } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

// images
import whatisnft from "../assets/whatisnft.jpg";
import featuredOne from "../assets/featured/1.jpg";
import featuredTwo from "../assets/featured/2.jpg";
import featuredThree from "../assets/featured/3.jpg";
//import howToGet from "../assets/howtoget.png";
import perk1 from "../assets/perks/perks1.png";
import perk2 from "../assets/perks/perks2.png";
import perk3 from "../assets/perks/perks3.png";
import perk4 from "../assets/perks/perks4.png";
import perk5 from "../assets/perks/perks5.png";
import { useHomeStyles } from '../styles/home';
//import redeem from "./assets/redeem/Redeem-01.png";

export const HomeContent = () => {
   const classes = useHomeStyles(); // CUSTOM STYLES FOR PAGE

   return (
      <Paper elevation={0} className={classes.bodyPaper}>
         <Container style={{ padding: '0px 1%', textAlign: 'center' }}>
         <Typography variant="h4" style={{ fontWeight: 'bold', margin: '30px 0 30px 0' }} id="perks">
            Perks of VP Bunnies
         </Typography>
         
         <Grid container spacing={3} className={classes.perksContainer}>
            <Grid item xs={12} md={8} style={{ textAlign: 'left' }}>
               <Typography variant="h6">
               <b>They are Rare!</b>
               </Typography>
               <Typography paragraph>
               Only <b>2,222</b> unique generative VP Bunny NFTs will ever be minted. While all VP Bunnies are rare, not all VP Bunnies are of same rarity. You will find that some Bunnies will have super rare traits that has less than 2% chance of generating! The rarest of them all will come with a <b>Gold Pass</b> or <b>Silver Pass</b>, making these VP Bunnies a ton of fun to collect and trade. Visit the <Link component={RouterLink} to="/collections">Collections Page</Link> for rarity breakdown.
               </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
               <img src={perk1} alt="perk 1" style={{ height: '250px' }} />
            </Grid>
         </Grid>
         
         <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
               <img src={perk2} alt="perk 2" style={{ height: '200px' }} />
            </Grid>
            <Grid item xs={12} md={8} style={{ textAlign: 'left' }}>
               <Typography variant="h6">
               <b>Visual Identity</b>
               </Typography>
               <Typography paragraph>
               VP Bunny NFTs are your visual identity in the VP community. As the community grows in the years to come, this visual identity is proof that you were here since the beginning and were one of the earliest supporters of LasVegasVP. This identity will also be used on all future developments on LasVegasVP.com website.
               </Typography>
            </Grid>
         </Grid>

         <Grid container spacing={3} className={classes.perksContainer}>
            <Grid item xs={12} md={8} style={{ textAlign: 'left' }}>
               <Typography variant="h6">
               <b>Special Access</b>
               </Typography>
               <Typography paragraph style={{ padding: '0px', textAlign: 'left' }}>  
               Owning a VP Bunny will give you access to private after dark live streams, all future meet up events, in person group pulls, and lifetime access to the complete archive of VP live stream videos. You will also be invited to vote on what games to play on special streams and more.<br /><br />
               </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
               <img src={perk3} alt="perk 3" style={{ height: '200px' }} />
            </Grid>
         </Grid>

         <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
               <img src={perk4} alt="perk 4" style={{ height: '250px' }} />
            </Grid>
            <Grid item xs={12} md={8} style={{ textAlign: 'left' }}>
               <Typography variant="h6">
               <b>Lifetime Sub, Dine & Play</b>
               </Typography>
               <Typography paragraph>
               As a celebration of this unique minting of VP Bunnies, 2 Gold Passes and 5 Silver Passes will appear on 7 of the VP Bunnies.<br /><br />

               The <b>Gold Pass</b> VP Bunny owners may each redeem a FREE LIFETIME Subscription to LasVegasVP's Twitch channel for their Twitch account. This is an once in a lifetime opportunity as our Twitch channel is only ever allowed to give out 3 LIFETIME Subscriptions and they cannot be purchased.<br /><br />

               In addition, both the <b>Gold Pass</b> and <b>Silver Pass</b> VP Bunny owners may redeem their pass, <b>once per year*</b>, for a Dine and Play experience with either VP, Marcus, or both. The Dine & Play experience comes with a fully paid for lunch or dinner at a nice casino restaurant followed by 1 hour of gaming. Pass holder is responsible for their own gaming budget.<br /><small>*For as long as livestream is active.</small><br /><br />
               </Typography>
            </Grid>
         </Grid>

         <Grid container spacing={3} className={classes.perksContainer}>
            <Grid item xs={12} md={8} style={{ textAlign: 'left' }}>
               <Typography variant="h6">
               <b>Sell & Trade</b>
               </Typography>
               <Typography paragraph>
               After all 2,222 VP Bunny NFTs are minted, the collection will be listed on NFT Marketplaces such as Magic Eden (pre-approved). You will be free to sell them or trade them with other fans and NFT collectors alike. LasVegasVP will also use these Marketplaces to purchase them for future giveaways.
               </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
               <img src={perk5} alt="perk 5" style={{ height: '200px' }} />
            </Grid>
         </Grid>
         </Container>

         <Container style={{ padding: '0px 2%', textAlign: 'center' }}>
         <Typography variant="h4" style={{ fontWeight: 'bold', margin: '30px 0 30px 0' }}>
            Featured Bunnies
         </Typography>
         
         <Container style={{ display: 'flex' }}>
            <Grid container spacing={3}>
               <Grid item xs={12} md={4} container justifyContent='center'>
               {/* START OF CARD */}
               <Card className={classes.card} raised>
                  <CardActionArea>
                     <CardMedia
                     component="img"
                     alt="VP Bunny"
                     height="250"
                     image={featuredOne}
                     title="VP Bunny"
                     />
                     <CardContent style={{ backgroundColor: '#fff' }}>
                     {/* <Typography gutterBottom variant="h5" component="h2">
                        VP Bunny
                     </Typography> */}
                     <Typography variant="body2" color="textSecondary" component="p" style={{ textAlign: 'left', color: '#333' }}>
                        Coming soon.
                     </Typography>
                     </CardContent>
                  </CardActionArea>
                  <CardActions style={{ backgroundColor: '#fff' }}>
                     <Button size="small" color="primary" style={{ width: '100%', backgroundColor: '#9334ff', color: '#fff', fontWeight: 'bold' }}>
                     View Details
                     </Button>
                  </CardActions>
               </Card>
               {/* END OF CARD */}
               </Grid>
               <Grid item xs={12} md={4} container justifyContent='center'>
               {/* START OF CARD */}
               <Card className={classes.card} raised>
                  <CardActionArea>
                     <CardMedia
                     component="img"
                     alt="VP Bunny"
                     height="250"
                     image={featuredTwo}
                     title="VP Bunny"
                     />
                     {/* <img src={whatisnft} /> */}
                     <CardContent style={{ backgroundColor: '#fff' }}>
                     {/* <Typography gutterBottom variant="h5" component="h2">
                        VP Bunny
                     </Typography> */}
                     <Typography variant="body2" color="textSecondary" component="p" style={{ textAlign: 'left', color: '#333' }}>
                        Coming Soon.
                     </Typography>
                     </CardContent>
                  </CardActionArea>
                  <CardActions style={{ backgroundColor: '#fff' }}>
                     <Button size="small" color="primary" style={{ width: '100%', backgroundColor: '#9334ff', color: '#fff', fontWeight: 'bold' }}>
                     View Details
                     </Button>
                  </CardActions>
               </Card>
               {/* END OF CARD */}
               </Grid>
               <Grid item xs={12} md={4} container justifyContent='center'>
               {/* START OF CARD */}
               <Card className={classes.card} raised>
                  <CardActionArea>
                     <CardMedia
                     component="img"
                     alt="VP Bunny"
                     height="250"
                     image={featuredThree}
                     title="VP Bunny"
                     />
                     <CardContent style={{ backgroundColor: '#fff' }}>
                     {/* <Typography gutterBottom variant="h5" component="h2">
                        VP Bunny
                     </Typography> */}
                     <Typography variant="body2" color="textSecondary" component="p" style={{ textAlign: 'left', color: '#333' }}>
                        Coming soon.
                     </Typography>
                     </CardContent>
                  </CardActionArea>
                  <CardActions style={{ backgroundColor: '#fff' }}>
                     <Button size="small" color="primary" style={{ width: '100%', backgroundColor: '#9334ff', color: '#fff', fontWeight: 'bold' }}>
                     View Details
                     </Button>
                  </CardActions>
               </Card>
               {/* END OF CARD */}
               </Grid>
            </Grid>
         </Container>
         </Container>

         <Container style={{ padding: '0px 2%', textAlign: 'center', margin: '30px 0' }}>
         <Typography variant="h4" style={{ fontWeight: 'bold', margin: '30px 0 30px 0' }}>
            How to get a VP Bunny NFT
         </Typography>
         
         <Grid container spacing={3}>
            <Grid item xs={12} md={6} container justifyContent="center" alignItems="center">
               <TikTokEmbed url="https://www.tiktok.com/@lasvegasvp/video/7078777842649025838" width={325} />
               {/* <img src={howToGet} alt="how to get a vp bunny collectible NFT?" style={{ width: '100%', borderRadius: 10, boxShadow: '10px 10px 43px -24px rgba(0,0,0,0.75)' }} /> */}
            </Grid>
            <Grid item xs={12} md={6} style={{ color: '#000', textAlign: 'left' }}>
               <ul className={classes.list} style={{ margin: '0 0 0 -20px' }}>
                  <li>
                     <Typography>The VP Bunny NFTs collection is built on the environmentally friendly Solana blockchain. All proceeds will be reinvested into live stream.</Typography></li>
                  <li>
                     <Typography>Be sure learn <a href="/help#generatingwallet">how to generate a Solana wallet</a> for yourself in order to store or sell your VP Bunny NFT.</Typography></li>
                  <li>
                     <Typography>There are 2 ways to obtain a VP Bunny NFT:</Typography>
                     <ol className={classes.innerList}>
                     <li>
                        <Typography variant="body2">
                           VP Bunny NFT can be bought with Carrots via the VP Carrot Shop. Each NFT will cost 5000 Carrots at the shop. You must provide your Solana wallet address in order to receive the NFT. After the Carrot Shop purchase, the NFT will be freshly minted by LasVegasVP and sent to your provided Solana wallet address.
                        </Typography>
                     </li>
                     <li>
                        <Typography variant="body2">
                           Alternatively, you may mint your own VP Bunny NFT with the Bunny Recruiter above. Each mint costs 1 Solana (SOL) plus gas fees at the Bunny Recruiter. You will need to learn <a href="/help#howtobuysolana">how to purchase Solana (SOL)</a> from a crypto exchange if you do not already have any.
                        </Typography>
                     </li>
                     </ol>
                  </li>
                  <li><Typography><b>Once all 2,222 Bunnies have been minted, the collection will be listed on NFT Marketplaces such as Magic Eden and Solanart.</b></Typography></li>
               </ul>
            </Grid>
         </Grid>
         </Container>

         <Container style={{ padding: '20px 2%', textAlign: 'left',  margin: '30px 0' }}>
         <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
               <Typography variant="h4" style={{ fontWeight: 'bold' }} gutterBottom>
               What is an NFT?
               </Typography>
               <Typography style={{ lineHeight: '1.8', color: '#8c8c8c' }}>
                  NFT stands for non-fungible token. It is a one-of-a-kind digital token that you can buy or sell. These tokens can represent just about anything, and they use blockchain technology to prove ownership. Sometimes they are associated with a digital image, or video. Sometimes they can be redeemed for a perk. Sometimes the owner is entitled to an experience, like a dinner. VP Bunny NFTs represent access to special streams and video archive, various events, dine and play experiences and more. For more information, check out our <a href="/help">Help Guide</a>.
               </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
               <img src={whatisnft} alt="what is an nft?" style={{ width: '100%' }} />
            </Grid>
         </Grid>
         </Container>
      </Paper>
   )
}